// useSessionStatus.js
// -----------------------------------------------------------------------------
// Hook expose l'etat de la session : "checking" | "valid" | "invalid".
// Tant que l'etat vaut "checking", aucun contenu authentifie ne doit etre rendu.
// -----------------------------------------------------------------------------
import { useEffect, useState } from "react";
import {
  verifySession,
  SESSION_CHECKING,
  SESSION_VALID,
  SESSION_INVALID,
} from "../helpers/sessionValidation";

const useSessionStatus = () => {
  // Si aucun token n'est present, inutile de passer par l'etat "checking" :
  // la session est invalide des le premier rendu (redirection immediate).
  const hasToken = !!localStorage.getItem("token");
  const [status, setStatus] = useState(
    hasToken ? SESSION_CHECKING : SESSION_INVALID
  );

  useEffect(() => {
    let isMounted = true;

    if (!hasToken) {
      setStatus(SESSION_INVALID);
      return undefined;
    }

    verifySession().then((isValid) => {
      if (isMounted) {
        setStatus(isValid ? SESSION_VALID : SESSION_INVALID);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [hasToken]);

  return status;
};

export { useSessionStatus };
export default useSessionStatus;
